<script>
export default {
  name: "CitimeLayout"
}
</script>

<template>
 <router-view></router-view>
</template>

<style scoped>

</style>